/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: '',
      component: () => import('./layouts/main/Main.vue'),
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: '/',
          name: 'home',
          redirect: '/pages/login'
         // component: () => import('./views/Home.vue')
        },
        {
          path: '/showroomProfile',
          name: 'Showroom-Profile',
          component: () => import('./views/ShowroomProfile'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/showroomDashboard',
          name: 'Showroom-Dashboard',
          component: () => import('./views/ShowroomDashboard.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/applicantInfo',
          name: 'Applicant-Information',
          component: () => import('./views/ApplicantInformations.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/applicantProfile',
          name: 'page-profile',
          component: () => import('./views/ApplicantProfile.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/guarantorInfo',
          name: 'Guarantor-Information',
          component: () => import('./views/GuarantorInformations.vue')
        },
        {
          path: '/showroom_dashboard',
          name: 'Showroom User',
          component: () => import('./views/showroomUser/ShowroomUserDashboard.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/showroom_footfall',
          name: 'showroom footfall',
          component: () => import('./views/ShowroomFootfall.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/try_and_buy',
          name: 'try_and_buy',
          component: () => import('./views/WashingMachineTrail.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/customer_verification',
          name: 'customer_verification',
          component: () => import('./views/CustomerVerifications.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/customer_wise_product_report',
          name: 'customer_wise_product_report',
          component: () => import('./views/CustomerWiseProductReport.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/new_try_and_buy',
          name: 'new_try_and_buy',
          component: () => import('./views/WashingMachineTrailAdd.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/update_try_and_buy/:id',
          name: 'update_try_and_buy',
          component: () => import('./views/WashingMachineTrailUpdate.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/new_footfall',
          name: 'new showroom footfall',
          component: () => import('./views/AddFootfall.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/footfallDetails/:id',
          name: 'footfall_details',
          component: () => import('./views/FootFallDetails'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/updateFootfall/:id',
          name: 'update_footfall',
          component: () => import('./views/UpdateFootfall.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/purchaseApplication',
          name: 'purchase_applications',
          component: () => import('./views/PurcheseApplication'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/updatePersonalInfo/:guarantorId/:ekycId/:purchaseId',
          name: 'update_guarantor_personal_info',
          component: () => import('./views/UpdateAppPersonalInfo'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/updateContactInfo/:guarantorId/:ekycId/:purchaseId',
          name: 'update_guarantor_contact_info',
          component: () => import('./views/UpdateAppContactInfo.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/updateOccupation/:guarantorId/:ekycId/:purchaseId',
          name: 'update_guarantor_occupation_info',
          component: () => import('./views/UpdateAppOccupationInfo'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/updateDependant/:guarantorId/:ekycId/:purchaseId/:applicationId',
          name: 'update_guarantor_dependant_info',
          component: () => import('./views/UpdateAppDependentInfo'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/updateOccupationInfo',
          name: 'update_app_occupation_info',
          component: () => import('./views/UpdateAppOccupationInfo'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/updateDependentInfo',
          name: 'update_app_dependent_info',
          component: () => import('./views/UpdateAppDependentInfo'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/applicationDetails/:applicationId',
          name: 'application_details',
          component: () => import('./views/ApplicationDetails'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/application-details/:id',
          name: 'application-details',
          component: () => import('./views/ApplicationDetailsForChange.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/update-contact/:ekyc_id',
          name: 'update-contact',
          component: () => import('./views/Components/UdateApplicantContactInfo.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/update-occupation/:ekyc_id',
          name: 'update-contact',
          component: () => import('./views/Components/UdateApplicantOccupationInfo.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/update-dependant/:ekyc_id',
          name: 'update-dependant',
          component: () => import('./views/Components/UdateApplicantDependantInfo.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/update-personal/:ekyc_id',
          name: 'update-personal',
          component: () => import('./views/Components/UdateApplicantPersonal.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/hire_agreement/:applicationId',
          name: 'hire-agreement',
          component: () => import('./views/HireAgreements'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/guarantorDetails/:guarantorId',
          name: 'guarantor_details',
          component: () => import('./views/GuarantorDetails'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/compare-application',
          name: 'compare-application',
          component: () => import('./views/Components/ExcelCompare'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/page2',
          name: 'page-2',
          component: () => import('./views/Page2.vue')
        }
      ]
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: '/pages/login',
          name: 'page-login',
          component: () => import('@/views/pages/Login.vue'),
          meta: {
            requiresGuest: true
          }
        },
        {
          path: '/pages/register',
          name: 'page-register',
          component: () => import('@/views/pages/register/Register.vue'),
          meta: {
            requiresGuest: true
          }
        },
        {
          path: '/pages/forgot-password',
          name: 'page-forgot-password',
          component: () => import('@/views/pages/passwordRecovery/ForgotPassword.vue'),
          meta: {
            requiresGuest: true
          }
        },
        {
          path: '/pages/otp',
          name: 'page-otp',
          component: () => import('@/views/pages/passwordRecovery/OTPPage.vue'),
          meta: {
            requiresGuest: true
          }
        },
        {
          path: '/pages/reset-password',
          name: 'page-reset-password',
          component: () => import('@/views/pages/passwordRecovery/ResetPassword.vue'),
          meta: {
            requiresGuest: true
          }
        },
        {
          path: '/pages/error-404',
          name: 'page-error-404',
          component: () => import('@/views/pages/Error404.vue'),
          meta: {
            requiresGuest: true
          }
        },
        {
          path: '/guarantor/:token',
          name: 'page-guarantor',
          component: () => import('@/views/ApplicantPreviewForGuarantor.vue')
        },
        {
          path: '/guarantorInfos/:guarantorId/:ekycId?',
          name: 'page-guarantor-info',
          component: () => import('@/views/GuarantorInformations.vue')
        },
        {
          path: '/submitted',
          name: 'page-guarantor-info-submission',
          component: () => import('@/views/GuarantorSubmitSuccess.vue')
        },
        {
          path: '/greetings-submission',
          name: 'page-guarantor-greetings-submission',
          component: () => import('@/views/GuarantorAlreadySubmit.vue')
        },
        {
          path: '/reject-submission',
          name: 'page-guarantor-reject-submission',
          component: () => import('@/views/GuarantorRejectSubmit.vue')
        },
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/pages/error-404'
    }
  ]
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

// router.beforeEach((to, from, next) => {
//   if (to.matched.some(record => record.meta.requiresAuth)) {
//     // this route requires auth, check if logged in
//     // if not, redirect to login page.
//     if (!auth.loggedIn()) {
//       next({
//         path: '/login',
//         query: { redirect: to.fullPath }
//       })
//     } else {
//       next()
//     }
//   } else {
//     next() // make sure to always call next()!
//   }
// })




router.beforeEach((to, from, next) => {
  // Check for requiresAuth guard
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // Check if NO logged user
    if (localStorage.getItem('apollo-token') === null) {
      // Go to login
      next({
        path: '/pages/login',
        query: {
          redirect: to.fullPath
        }
      })
    } else {
      // Proceed to route
      next()
    }
  } else if (to.matched.some(record => record.meta.requiresGuest)) {
    // Check if NO logged user
    if (localStorage.getItem('apollo-token') !== null) {
      // Go to login
      next({
        path: '/showroomDashboard',
        query: {
          redirect: to.fullPath
        }
      })
    } else {
      // Proceed to route
      next()
    }
  } else {
    // Proceed to route
    next()
  }
})
export default router
